(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sswinstagram"] && !Shopify.designMode) return;
  try {
    
  var addInstaHandle = function () {
    var title = document.querySelector('.ssw-instagram-grid-title');
    if (!title) {
      setTimeout(function () {
        addInstaHandle();
      }, 100);
      return;
    }

    var handle = document.createElement('h3');
    handle.className = 'mini-heading ac';
    handle.innerHTML = '<a href="https://www.instagram.com/otherlandco/">@otherlandco</a>';
    title.parentNode.insertBefore(handle, title);
  };

  window.onload = function () {
    addInstaHandle();
  };

  } catch(e) { console.error(e); }
})();
})();
